import DesktopView from "../components/desktopview/DesktopView";
import Header from "../components/header/Header";

import React, { useEffect, useState } from "react";

export default function Setting() {
  const [isPiecesAnimOn, setisPiecesAnimOn] = useState(true);
  const [isNotifOn, setIsNotifOn] = useState(true);

  return (
    <>
      <div className="hidden min-[1024px]:block">
        <DesktopView />
      </div>
      <div
        className="relative w-full h-screen flex flex-col items-center justify-between bg-[#153038] min-[1024px]:hidden"
        onClick={() => {}}
      >
        <Header />

        <div
          className={`w-[95vw] h-full flex flex-col items-start justify-start px-[6vw] gap-y-[2vw] `}
        >
          <div className="w-full flex items-center justify-center p-[2vw]  my-[8vw] ">
            <p className="font-font_primary_A text-[5.5vw] text-white font-bold">
              تنظیمات
            </p>
          </div>
          <div
            className="w-full relative h-[12vw] flex items-center justify-between p-[2vw] border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[4vw]"
            onClick={(e) => {
              e.stopPropagation();
              //   setIsSupportRequest("true");
            }}
          >
            <p className="font-font_primary_A text-[3.5vw] font-light text-white">
              نمایش انیمیشن (متحرک سازی)
            </p>
            <div
              className={`w-[12vw] h-[3.5vw] flex items-center rounded-full border-[1px] border-black transition-all duration-600 ${
                isPiecesAnimOn ? " bg-color-primary-B" : " bg-color-primary-C"
              }`}
              onClick={() => {
                setisPiecesAnimOn((prev) => !prev);
              }}
            >
              <div
                className={`w-[5vw] h-[5vw] bg-white rounded-full transition-all duration-600 ${
                  isPiecesAnimOn ? "-translate-x-[7vw]" : "-translate-x-[0vw]"
                }`}
              ></div>
            </div>
          </div>

          {/* //// notif section start //// */}
          {"Notification" in window && (
            <div
              className="w-full relative h-[12vw] flex items-center justify-between p-[2vw] border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[4vw]"
              onClick={(e) => {
                e.stopPropagation();
                //   setIsSupportRequest("true");
              }}
            >
              <p className="font-font_primary_A text-[3.5vw] font-light text-white">
                نوتیفیکیشن
              </p>
              <div
                className={`w-[12vw] h-[3.5vw] flex items-center rounded-full border-[1px] border-black transition-all duration-600 ${
                  isNotifOn ? " bg-color-primary-B" : " bg-color-primary-C"
                }`}
                // onClick={askForNotifPermission}
              >
                <div
                  className={`w-[5vw] h-[5vw] bg-white rounded-full transition-all duration-600 ${
                    isNotifOn ? "-translate-x-[7vw]" : "-translate-x-[0vw]"
                  }`}
                ></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
